// Selected patient id as stored in the survey answers: 0 is the main patient,
// a number is a relative id, undefined/null means no selection yet.
export type SelectedPatientId = number | string | null | undefined

export const isMainPatient = (id: SelectedPatientId): boolean =>
  id === 0 || id === undefined || id === null

// relative_id to send to the API; omitted for the main patient.
export const getUploadRelativeId = (
  id: SelectedPatientId,
): string | number | undefined => (isMainPatient(id) ? undefined : id)

// Documents belonging to the selected patient. The API returns
// relative_id === null for documents of the main patient.
export const filterDocsForSelectedPatient = <T extends { relative_id: unknown }>(
  docs: T[],
  id: SelectedPatientId,
): T[] =>
  id === 0
    ? docs.filter((doc) => doc.relative_id === null)
    : docs.filter((doc) => doc.relative_id === id)

// `${baseUrl}?relative_id=<id>&<extra>`; relative_id is omitted for the main
// patient and extra params with an empty value are skipped.
export const withRelativeIdQuery = (
  baseUrl: string,
  id: SelectedPatientId,
  extra: Record<string, string | undefined> = {},
): string => {
  const params = new URLSearchParams()
  if (!isMainPatient(id)) params.set("relative_id", String(id))
  Object.entries(extra).forEach(([key, value]) => {
    if (value) params.set(key, value)
  })
  const query = params.toString()
  return query ? `${baseUrl}?${query}` : baseUrl
}
